$(document).ready(function() {
    var $element = $('#sm_imageslider_8650467521685604343'),
        $sm_imageslider = $('.sm-imageslider-content', $element);

    $(window).on('load', function () {
        setTimeout(function () {
            $('.sm-imageslider-loading', $element).remove();
            $element.removeClass('imgsl-preload');
            __runImageSlider();
        }, 1000);

    });

    function __runImageSlider() {
        $sm_imageslider.owlCarousel({
            center: false,
            nav: true,
            loop: true,
            dots: false,
            dotsSpeed: 2000,
            merge:true,
            margin: 1,
            navText: ['&#139;', '&#155;'],
            slideBy: 1,
            autoplay: true,
            autoplayTimeout: 3500,
            autoplayHoverPause: true,
            autoplaySpeed: 1000,
            startPosition: 0,
            navSpeed: 2000,
            mouseDrag: true,
            responsive: {
                0: {
                    items:1                            },
                768: {
                    items:1                            }
            },
            autoHeight: true,
            responsiveRefreshRate: 100,
            onInitialized: function (e) {
                                        }
        });
    }

    function getHeightImage() {
        var _image = $('.item-image img', $element);
        if (_image.length <= 0)
            _image = $('.item-image', $element);
        var _max_item = null;
        if (_image.length) {
            var hf = 0;
            _image.each(function () {
                var h = $(this).height();
                if (h > hf) {
                    hf = h;
                    _max_item = $(this);
                }
            });

            var maxHeight = _max_item.height();
            var heroSearch = $('.hero__search');
            if (heroSearch) {
                maxHeight = heroSearch.height();
            }

            $('.item-image img', $element).height(maxHeight);
        }
    }

    $sm_imageslider.on('resized.owl.carousel refreshed.owl.carousel', function () {
        var _image = $('.item-image img', $element);
        if (_image.length) {
            _image.each(function () {
                $(this).removeAttr('style');
            });
        }
        getHeightImage();
    });
})